import { CrewInfo } from "./CrewInfo";

export class ExternalCrewInfo extends CrewInfo {
    firstAccess: boolean;
    hasAccess: boolean;
    blocked: boolean;
    requiresMfa: boolean;
    maskedEmail: string;
    accessDeniedMessage: string;
    base: string;
    companyDomain: string;
    companyDomains: string[];
}
